import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import CatalogItem from "../../models/catalog-item";
import CatalogItemForm from "./CatalogItemForm";

interface CatalogItemUpdateModalProps {
  show: boolean;
  catalogItem?: CatalogItem;
  currency?: string;
  onCancel: () => void | Promise<void>;
  onSuccess: (_?: CatalogItem) => void | Promise<void>;
}

const CatalogItemUpdateModal: React.FC<CatalogItemUpdateModalProps> = ({
  show,
  catalogItem,
  currency,
  onCancel,
  onSuccess,
}) => {
  const isEditing = catalogItem !== undefined && catalogItem.id !== undefined;

  return (
    <CModal show={show} onClose={onCancel} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>
          {isEditing ? "Editar producto o servicio" : "Nuevo producto o servicio"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <CatalogItemForm
              catalogItem={catalogItem}
              initialCurrency={currency}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default CatalogItemUpdateModal;
